import { useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';

type TVTextFieldProps = TextFieldProps & {
  id?: string;
  valor?: (id: string, valor: string) => void;
}

export const VFieldMoney2Faturamento: React.FC<TVTextFieldProps> = ({ valor, id, ...rest }) => {

  const formatValue = (inputValue: string | number): string => {
    let formattedValue: string;

    if (typeof inputValue === 'number') {
      inputValue = inputValue.toString();
    }

    if (!inputValue.includes('.')) {
      formattedValue = inputValue.replace(/\D/g, '');
      formattedValue += ',00'; // 🔥 alterado para 2 casas
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.');
    } else {
      formattedValue = inputValue.replace(/\./g, ',');
      formattedValue = formattedValue.replace(/(\d+,\d{0,2})\d*/, '$1'); // 🔥 alterado
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.');
    }

    return formattedValue;
  };

  const formatInputValue = (inputValue: string) => {
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.replace(/(\d)(\d{2})$/, '$1,$2'); // 🔥 alterado
    inputValue = inputValue.replace(/(?=(\d{3})+(\D))\B/g, '.');
    return inputValue;
  };

  const formatSimple = (inputValue: string): string => {
    inputValue = inputValue.replace(/\./g, '');
    inputValue = inputValue.replace(/,/g, '.');
    return inputValue;
  };

  const [value, setValue] = useState(formatValue(String(rest.defaultValue)));

  return (
    <TextField
      {...rest}
      value={value}
      onChange={e => {
        const formatted = formatInputValue(e.target.value);

        setValue(formatted);

        valor?.(id || '', formatSimple(formatted));

        rest.onChange?.(e);
      }}
      onKeyDown={(e) => {
        rest.onKeyDown?.(e);
      }}
    />
  );
};